<script lang="ts">
	import { articles, reviews } from '$lib/config/shared';
	import CaseStudyItem from './CaseStudyItem.svelte';
	import { swipe } from 'svelte-gestures';
	import { onMount } from 'svelte';
	import { CarouselHelper } from '$lib/helpers/swipe.helper';
	import type { Article } from '$lib/domain/article.interface';
	import type { Review } from "$lib/domain/review.interface";

	export let explicitArticles: Article[] = [];
	export let targetReviews: Review[] = [];
	export let title: string | '' = 'Case Studies';
	export let description: string | '' = '';

	let activeIndex = 0;
	const caseStudies = (
			explicitArticles.length ? explicitArticles
					: articles.filter((item) => !!item.caseStudyTitle)).map((item) => {
						const targetReview = targetReviews.length ? targetReviews.find((review) =>
								review.relatedArticleUrls.some((url) => item.url.includes(url))) : reviews.find((review) =>
								review.relatedArticleUrls.some((url) => item.url.includes(url)))
						return {
							article: item,
							review: targetReview
						};
					});

	const maxCount = caseStudies.length;
	const carouselHelper = CarouselHelper.getInstance(maxCount);

	onMount(() => {
			if (!window.matchMedia('(max-width: 1400px)').matches) {
					return;
			}

			carouselHelper.resetInterval();
			carouselHelper.indexStore.subscribe((index) => (activeIndex = Number(index)));
	});
</script>

<div class="container case-studies flex-column">
	<div class="section-title flex-column-center">
		<h2>{@html title}</h2>
	</div>
	
	{#if !!description}
		<p class="h5">{@html description}</p>
	{/if}
	
	<div
		class="case-studies-list"
		use:swipe="{{ timeframe: 300, minSwipeDistance: 60, touchAction: 'pan-y' }}"
		on:swipe="{carouselHelper.handleSwipe}">
		{#each caseStudies as item, i}
			<article class:active="{activeIndex === i}" class="case-study-block">
				<CaseStudyItem item="{item}" reverse="{i % 2 !== 0}" />
			</article>
		{/each}
	</div>
	
	<ol class="carousel-indicators">
		{#each Array(maxCount) as _, i}
			<li
				on:click="{() => carouselHelper.select(i)}"
				on:keydown="{() => carouselHelper.select(i)}"
				class:active="{i === activeIndex}">
				<div class="carousel-bullet">•</div>
			</li>
		{/each}
	</ol>
</div>

<style lang="scss">
	@import '$styles/vars';

	.case-studies {
		align-items: center;

		.section-title{
			text-align: center;
		}

		.h5 {
			line-height: 28px;
			text-align: center;
			padding-left: 16px;
			padding-right: 16px;
			max-width: 70%;
			margin-top: 24px;
		}

		&-list {
			margin-top: 60px;
			width: 100%;
			max-width: 100%;
			row-gap: 60px;

			article {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				width: 100%;
				position: relative;
				background-size: 1000px auto;
				background-position: left;
				background-repeat: no-repeat;
				min-height: 525px;

				&:not(:first-child) {
					margin-top: 40px;
				}
			}
		}

		.carousel-indicators {
			display: none;
		}
	}

	@media (min-width: $portrait-phone-size) and (max-width: $tablet-size) {
		.case-studies {
			&-list {
				article {
					background-size: 700px auto !important;
					min-height: 400px;
				}
			}
		}
	}

	@media (max-width: $portrait-phone-size) {
		.case-studies {
			.carousel-indicators {
				display: block;
			}

			.h5 {
				max-width: 100%;
				margin-bottom: 0;
			}

			&-list {
				margin-top: 48px;
				padding: 16px 0;

				article {
					display: none;
					margin-top: unset !important;
					min-height: unset !important;
					background-size: 600px auto !important;
					background-position: top !important;

					&.active {
						display: flex;
					}
				}
			}
		}
	}
</style>
